import * as React from "react"
import BrandStore from "stores/BrandStore"
import { observer, inject } from "mobx-react"

interface WaiverFieldProps {
  store?: BrandStore
  waiverUrl?: string
  checked: boolean
  prefChecked: boolean
  onChange(checked: boolean): void
  onPrefChange(checked: boolean): void
  isPurchase?: boolean
}

const WaiverField: React.FunctionComponent<WaiverFieldProps> = ({
  store,
  waiverUrl,
  checked,
  prefChecked,
  onChange,
  onPrefChange,
  isPurchase = false
}) => {
  const url = waiverUrl ? waiverUrl : store!.locStore.currentLocation!.waiverUrl
  const termsText = isPurchase ? "Purchase Terms and Conditions" : "Terms and Conditions of Service"
  let locationName = ''

  async function getLocationName(locData: any) {
    const url = `/api/locations/${locData}`
    const respLocInfo =  await fetch(url)
    const respLocInfoData = await respLocInfo.json()
    const locPicker = document.getElementsByClassName('location-picker__toggle')
    if(locPicker.length){
      locPicker[0].innerHTML = respLocInfoData.location.name
    }
    locationName = respLocInfoData.location.id
  }

  // When in a logged out state, no current location is set and a location call needs to be made
  // to get the current location data using query param id

  const locationQueryParam = store!.routingStore.query.location_id ? store!.routingStore.query.location_id : store!.routingStore.query.location
  locationQueryParam
    ? getLocationName(locationQueryParam)
    : locationName = store!.locStore.currentLocation!.name

  return (
    <>
      <div className="text-left mb-3">
        <small>By submitting this form and providing your contact information, you agree to receive emails, phone calls and text messages that are permissible to send to you under all applicable federal, state and local laws. Message frequency varies. You can opt-out at any time by replying STOP or requesting that {store!.brand.name} stop calling, texting or emailing you. Message and data rates may apply. </small>
      </div>
      <label className="text-left mb-3">
        <span>
          <input
            type="checkbox"
            checked={checked}
            onChange={e => onChange(e.currentTarget.checked)}
          />
        </span>{" "}
        <small>
          By completing this form and using this website, you agree to be bound by{" "}
          <a
            href="#"
            onClick={e => {
              e.preventDefault()
              store!.uiStore.openModal({
                title: `Terms & Conditions for ${store!.brand.name} ${
                  locationName
                }`,
                children: (
                  <iframe
                    className="w-100 border-0"
                    style={{ height: "80vh" }}
                    src={url}
                  />
                ),
                modalShow: true,
                size: "lg",
              })
            }}
          >
            {`${store!.brand.name} ${termsText}`}
          </a>
          ,{" "}
          <a href={`${store!.brand.siteUrl}/terms`} target="_blank" rel="nofollow">Terms and Conditions</a>
          {" "}and{" "}
          <a href={`${store!.brand.siteUrl}/privacy`} target="_blank" rel="nofollow">Privacy Policy</a>
          .
        </small>
      </label>
      <label className="text-left mb-3">
        <span>
          <input
            type="checkbox"
            name="prefMarketingSms"
            checked={prefChecked}
            onChange={e => onPrefChange(e.currentTarget.checked)}
          />
        </span>{" "}
        <small>
          By checking this box, you agree to receive marketing and promotional messages and telephone calls from the Studio to which you are supplying your contact information as well as from {store!.brand.name}. Message frequency varies. Messages may be sent using an automatic telephone dialing system or a prerecorded or artificial voice. Consent to receiving promotional messages and calls is not a condition of purchase or to receiving any products or services. Message and data rates may apply. Text STOP to cancel. Text HELP for help.
        </small>
      </label>
    </>
  )
}

export default inject((store: BrandStore) => ({ store }))(observer(WaiverField))
